import { useState, useEffect } from "react";
import axios from "axios";
import LykioButton from "../common/LykioButton";
import Form from "react-bootstrap/Form";
import {
  AUTHORIZED_URL_PREFIX,
  NOTIFICATION_SEVERITY_SUCCESS,
  ACCESS_CODES,
  CREATE_ACCESS_CODE_URL,
  AxiosConfig,
} from "../../Utils/Constants";
import Loading from "../common/Loading";
import t from "../../Utils/Translation";
import { useNavigate } from "react-router";
import { notify, pleaseRefreshError } from "../../Utils/Notificator";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Table from "react-bootstrap/Table";
import friendlyDate from '../../Utils/FriendlyDate';

const AddAccessCode = () => {
  const navigate = useNavigate();
  const [level, setLevel] = useState(1);
  const [price, setPrice] = useState(0);
  const [duration, setDuration] = useState(365);
  const [availableCodes, setAvailableCode] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchAccessCodes = async () => {
      try {
        const { data } = await axios.get(
          `${AUTHORIZED_URL_PREFIX}${ACCESS_CODES}`,
          AxiosConfig()
        );
        if (data.success) {
          setAvailableCode(data.accessCodes);
          setIsLoading(false);
        } else {
          notify(pleaseRefreshError);
        }
      } catch (error) {
        console.error(error);
        notify(pleaseRefreshError);
      }
    };

    fetchAccessCodes();
  }, []);

  const addNewAccessCode = async (e) => {
    e.preventDefault();
    try {
      const { data } = await axios.post(
        `${AUTHORIZED_URL_PREFIX}${CREATE_ACCESS_CODE_URL}`,
        { level, price, duration },
        AxiosConfig()
      );
      if (data.success === true) {
        notify({
          title: `Code ${data.accessCode.serial} was successfully generated.`,
          severity: NOTIFICATION_SEVERITY_SUCCESS,
          creationDate: "",
        });
        setPrice(0);
        setDuration(365);
        setLevel(1);
		window.location.reload();
      } else {
        notify(pleaseRefreshError);
      }
    } catch (error) {
      console.log(error);
      notify(pleaseRefreshError);
    }
  };

  return (
    <div className="lykioccs-main-content">
      {isLoading ? (
        <Loading />
      ) : (
        <div className="lykiocss-center lykiocss-margin-top-2em">
          <Container>
            <Row>
              <Col>
                <Form
                  onSubmit={addNewAccessCode}
                  className="lykiocss-form lykiocss-form-border lykiocss-form-size"
                  style={{paddingBottom:'3.5rem'}}
                >
                  <h3 className="lykiocss-center">
                    {t("Add a new access code")}
                  </h3>

                  <Form.Group className="mb-3 lykiocss-margin-top-1em" controlId="group">
                    <Form.Label>{t("Level")}</Form.Label>
                    <Form.Control
                      required
                      type="number"
                      placeholder={t("Enter level")}
                      onChange={(e) => {
                        setLevel(e.target.value);
                      }}
                    />
                  </Form.Group>

                  <Form.Group className="mb-3" controlId="group">
                    <Form.Label>{t("Price")}</Form.Label>
                    <Form.Control
                      required
                      type="number"
                      placeholder={t("Enter price")}
                      onChange={(e) => {
                        setPrice(e.target.value);
                      }}
                    />
                  </Form.Group>

                  <Form.Group className="mb-3" controlId="group">
                    <Form.Label>{t("Duration")}</Form.Label>
                    <Form.Control
                      required
                      type="number"
                      placeholder={t("Enter duration in days")}
                      onChange={(e) => {
                        setDuration(e.target.value);
                      }}
                    />
                  </Form.Group>

                  <LykioButton variant="contained" className="float-end" type="submit" >
                    {t("Save")}
                  </LykioButton>
                </Form>
              </Col>
              <Col>
                {availableCodes.length<1 ? <div className='lykiocss-title-light lykiocss-center'>{t('You have not created any access codes yet')}</div> :
                <div className="table-responsive lykiocss-scrollable-table-400">
                  <Table striped bordered hover>
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>{t("Access Code")}</th>
                        <th>{t("Assigned To")}</th>
                        <th>{t("Level")}</th>
                        <th>{t("Duration")}</th>
                        <th>{t("Active")}</th>
                        <th>{t("Activated on")}</th>
                        <th>{t("Price")}</th>
                        <th>{t("Created on")}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {availableCodes.map((code, i) => {
                        return (
                          <tr>
                            <td>{i + 1}</td>
                            <td>{code.serial}</td>
                            <td>{code.user ? code.user.email : "nobody"}</td>
                            <td>{code.level}</td>
                            <td>{code.duration}</td>
                            <td>{code.active ? "yes" : "no"}</td>
                            <td>{code.activatedDate ? friendlyDate(code.activatedDate) : 'none'}</td>
                            <td>{code.price}</td>
                            <td>{code.creationDate ? friendlyDate(code.creationDate) : 'none'}</td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </Table>
                </div>}
              </Col>
            </Row>
          </Container>
        </div>
      )}
    </div>
  );
};

export default AddAccessCode;
